export * from './poll.interface';
